import { render } from "./ProjectSingleTile.vue?vue&type=template&id=3b17c860"
import script from "./ProjectSingleTile.vue?vue&type=script&lang=js"
export * from "./ProjectSingleTile.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__